import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DeviceSelectComponent } from './device-select.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule],
  declarations: [DeviceSelectComponent],
  exports: [DeviceSelectComponent]
})
export class DeviceSelectModule { }
